import { useNavigate } from "react-router-dom";
import Logo from "@/components/Logo";

const Welcome = () => {
    const navigate = useNavigate();
    return (
        <div className="screen relative" data-testid="auth-welcome-screen">
            {/* Ambient gold glow — richer, layered */}
            <div
                aria-hidden
                className="pointer-events-none absolute inset-0"
                style={{
                    background:
                        "radial-gradient(720px 520px at 50% 22%, hsl(41 70% 55% / 0.22), transparent 65%), radial-gradient(480px 360px at 50% 0%, hsl(41 80% 62% / 0.10), transparent 70%)",
                }}
            />

            <div className="relative z-10 flex-1 flex flex-col items-center px-8 pt-[14vh]">
                {/* Centered logo with subtle halo for presence */}
                <div className="relative">
                    <span
                        aria-hidden
                        className="absolute inset-0 -m-6 rounded-full animate-pulse-soft"
                        style={{
                            background:
                                "radial-gradient(closest-side, hsl(41 75% 55% / 0.22), transparent 70%)",
                        }}
                    />
                    <Logo size={140} className="relative" />
                </div>

                {/* Small label — bigger gap from logo */}
                <p
                    className="mt-14 text-[11.5px] font-semibold tracking-[0.30em] uppercase text-primary animate-fade-up"
                    data-testid="welcome-label"
                >
                    Welcome to Neyra
                </p>

                {/* Headline — dominant, tighter */}
                <h1
                    className="mt-5 font-display text-[32px] leading-[1.08] font-bold tracking-[-0.02em] text-center max-w-[19ch] animate-fade-up"
                    style={{ animationDelay: "90ms" }}
                    data-testid="welcome-headline"
                >
                    Connect with people around you
                </h1>

                {/* Subtext — higher contrast */}
                <p
                    className="mt-6 text-[14px] leading-[1.55] text-foreground/65 text-center max-w-[32ch] animate-fade-up"
                    style={{ animationDelay: "180ms" }}
                    data-testid="welcome-subtext"
                >
                    Discover real-life hangouts, sports, and services near you — in Lagos and
                    beyond.
                </p>
            </div>

            {/* Actions — extra breathing room */}
            <div
                className="relative z-10 px-7 pb-[max(34px,env(safe-area-inset-bottom))] pt-8 space-y-3 animate-fade-up"
                style={{ animationDelay: "280ms" }}
            >
                {/* Glow halo under button for premium depth */}
                <div className="relative">
                    <span
                        aria-hidden
                        className="pointer-events-none absolute inset-x-6 -bottom-2 h-6 rounded-full blur-2xl"
                        style={{ background: "hsl(41 75% 50% / 0.45)" }}
                    />
                    <button
                        data-testid="welcome-signup-btn"
                        onClick={() => navigate("/auth/signup")}
                        className="relative w-full h-[58px] rounded-full font-semibold text-[15.5px] text-white tracking-[-0.005em] active:scale-[0.98] transition-transform duration-200"
                        style={{
                            background:
                                "linear-gradient(135deg, #8A6B1E 0%, #B4892B 35%, #C9A43A 70%, #E0C168 100%)",
                            boxShadow:
                                "0 22px 48px -16px hsl(41 80% 40% / 0.55), 0 6px 14px -4px hsl(41 80% 35% / 0.40), inset 0 1px 0 hsl(0 0% 100% / 0.22), inset 0 -1px 0 hsl(41 70% 20% / 0.55)",
                        }}
                    >
                        <span
                            aria-hidden
                            className="pointer-events-none absolute inset-x-4 top-0.5 h-[40%] rounded-full opacity-40"
                            style={{
                                background:
                                    "linear-gradient(180deg, rgba(255,255,255,0.55), rgba(255,255,255,0) 100%)",
                            }}
                        />
                        Get Started
                    </button>
                </div>

                <button
                    data-testid="welcome-login-btn"
                    onClick={() => navigate("/auth/login")}
                    className="w-full h-12 rounded-full font-medium text-[14px] text-foreground/75 hover:text-foreground hover:bg-muted/50 transition-colors duration-200"
                >
                    I already have an account
                </button>
            </div>
        </div>
    );
};

export default Welcome;
